<template>
    <img
        class="w-auto h-10"
        src="/2026_EK-Liga_quer.png"
        alt="Logo">
</template>

<script setup>
</script>